import type { DesktopPreviewBridge, PreviewAutomationRequestOrigin } from "@t3tools/contracts";

type PreviewAutomationNavigationBridge = Pick<DesktopPreviewBridge, "navigate">;

/**
 * Requests from older servers may omit `origin`; those requests are agent
 * navigation by contract, not local browser-chrome navigation.
 */
export async function navigatePreviewAutomationTab(
  bridge: PreviewAutomationNavigationBridge,
  runtimeTabId: string,
  url: string,
  origin: PreviewAutomationRequestOrigin | undefined,
): Promise<void> {
  await bridge.navigate(runtimeTabId, url, origin ?? "agent");
}
